import React, { useEffect, useState } from "react";
import {
  Typography,
  Input,
  Modal,
  Button,
  Popover,
  Layout,
  Skeleton,
  Table,
  Select,
  Pagination,
  DatePicker,
  message,
} from "antd";
import { FileDoneOutlined } from "@ant-design/icons";
import {
  FaSearch,
  FaFilter,
  FaEye,
  FaPlus,
  FaClipboardList,
} from "react-icons/fa";
import { Get } from "../../config/api/get";
import { QUESTION, CATEGORIES, QUIZ } from "../../config/constants/api";
import { useSelector } from "react-redux";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { ImageUrl } from "../../helpers/Functions";
import "../course-management/course-management.css";

const { Option } = Select;

function QuizManagement() {
  const token = useSelector((state) => state.user.userToken);
  const userData = useSelector((state) => state.user.userData);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null); // eslint-disable-line no-unused-vars
  const [questions, setQuestions] = useState([]);
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });
  const navigate = useNavigate();

  const [filter, setFilter] = useState({
    status: null,
    keyword: "",
    from: null,
    to: null,
  });

  const startIndex =
    (paginationConfig.pageNumber - 1) * paginationConfig.limit + 1;
  const endIndex = Math.min(
    startIndex + paginationConfig.limit - 1,
    paginationConfig.totalDocs
  );
  const recordsMessage = `Showing records ${endIndex} of ${paginationConfig.totalDocs}`;

  useEffect(() => {
    getAllQuiz();
    getCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCategories = async () => {
    setLoading(true);
    const res = await Get(`${CATEGORIES.getAllcategories}`, token, {
      limit: "100",
    });

    setCategories(res.data.docs);
    setLoading(false);
  };

  const handlePageChange = (pageNumber) => {
    setPaginationConfig({
      ...paginationConfig,
      pageNumber: pageNumber,
    });

    getAllQuiz(pageNumber);
  };

  const handleSearch = (value) => {
    setFilter({
      ...filter,
      keyword: value,
    });
  };

  const handleStatusChange = (value) => {
    setFilter({
      ...filter,
      category: value,
    });
  };

  const resetFilter = () => {
    setFilter({
      category: "",
      keyword: "",
      from: null,
      to: null,
    });
    getAllQuiz(paginationConfig.pageNumber, paginationConfig.limit, "", true);
  };

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handleFrom = (date) => {
    setFilter({
      ...filter,
      from: date,
    });
  };

  const handleTo = (date) => {
    setFilter({
      ...filter,
      to: date,
    });
  };

  const handleLimitChange = (pageSize) => {
    setPaginationConfig({
      ...paginationConfig,
      limit: pageSize,
      current: 1,
    });

    getAllQuiz(1, pageSize);
  };

  const handleStatus = async () => {
    try {
      const index = questions.findIndex((user) => user._id === selectedUser._id);

      await Get(QUESTION.toggleStatus + "/" + selectedUser._id, token, {});
      const newUsers = [...questions];

      newUsers[index].isActive = !selectedUser.isActive;
      setModalOpen(false);
      setQuestions(newUsers);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getAllQuiz = async (pageNumber, pageSize, search, reset = false) => {
    setLoading(true);
    try {
      const response = await Get(QUIZ.getAllQuiz, token, {
        page: pageNumber
          ? pageNumber.toString()
          : paginationConfig.pageNumber.toString(),
        limit: pageSize
          ? pageSize.toString()
          : paginationConfig.limit.toString(),
        category: reset ? "" : filter.category || null,
        keyword: search ? search : null,
        from: reset ? "" : filter?.from ? filter?.from.toISOString() : "",
        to: reset ? "" : filter?.to ? filter?.to.toISOString() : "",
        createdBy: userData?._id,
      });
      setLoading(false);
      console.log("response", response);
      if (response?.data?.docs) {
        setQuestions(response?.data?.docs);
        setPaginationConfig({
          pageNumber: response?.data?.page,
          limit: response?.data?.limit,
          totalDocs: response?.data?.totalDocs,
          totalPages: response?.data?.totalPages,
        });
      } else {
        message.error("Something went wrong!");
        console.log("error====>", response);
      }
    } catch (error) {
      console.log(error.message);
      setLoading(false);
    }
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <button type="button" className="cm-pager-btn">
          Previous
        </button>
      );
    }
    if (type === "next") {
      return (
        <button type="button" className="cm-pager-btn">
          Next
        </button>
      );
    }
    return originalElement;
  };

  const columns = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      width: 70,
      render: (value, item, index) => (
        <span className="cm-index">{(index < 9 ? "0" : "") + (index + 1)}</span>
      ),
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (title) => (
        <span className="cm-title-cell" title={title}>
          {title}
        </span>
      ),
    },
    {
      title: "Course",
      dataIndex: "course",
      key: "course",
      render: (item) => (
        <span className="cm-category-cell" title={item?.title}>
          {item?.title}
        </span>
      ),
    },
    {
      title: "Lecture",
      dataIndex: "lecture",
      key: "lecture",
      render: (item) => (
        <span className="cm-category-cell">{item?.title || "N/A"}</span>
      ),
    },
    {
      title: "Passing Percent",
      dataIndex: "passingPercentage",
      key: "passingPercentage",
      render: (val) => <span className="cm-meta-cell">{val}</span>,
    },
    {
      title: "Due Date",
      dataIndex: "quizDate",
      key: "quizDate",
      render: (item) => (
        <span className="cm-meta-cell">{moment(item).format("ll")}</span>
      ),
    },
    {
      title: "Action",
      dataIndex: "_id",
      width: 120,
      key: "_id",
      render: (item) => (
        <div style={{ display: "flex", gap: 8 }}>
          <button
            type="button"
            className="cm-view-btn"
            aria-label="View quiz details"
            onClick={() => navigate("/quiz-details/" + item)}
          >
            <FaEye aria-hidden="true" />
          </button>
          <button
            type="button"
            className="cm-view-btn"
            aria-label="View quiz attempts"
            onClick={() => navigate("/quiz-attempts/" + item)}
          >
            <FileDoneOutlined />
          </button>
        </div>
      ),
    },
  ];

  const filterContent = (
    <div className="filterDropdown cm-filter-popover">
      <p className="cm-filter-head">Filter quizzes</p>
      <hr />

      <div className="filterDropdownBody">
        <p className="mainLabel">Start Date:</p>
        <DatePicker
          className="mainInput filterInput"
          value={filter.from}
          onChange={(e) => handleFrom(e)}
        />
        <DatePicker
          className="mainInput filterInput"
          value={filter.to}
          onChange={(e) => handleTo(e)}
        />

        <p className="mainLabel">Filter by Category:</p>

        <Select
          size={"large"}
          className="filterSelectBox cm-filter-select"
          placeholder="Select Option"
          value={filter?.category}
          onChange={(e) => handleStatusChange(e)}
        >
          {categories.map((item) => (
            <Option key={item._id} value={item._id}>
              {item?.title}
            </Option>
          ))}
        </Select>

        <Button
          type="primary"
          block
          size={"large"}
          className="loginButton cm-filter-apply"
          onClick={() => getAllQuiz()}
        >
          Apply
        </Button>
        <Button
          type="primary"
          block
          size={"large"}
          className="loginButton"
          onClick={() => resetFilter()}
        >
          Clear All
        </Button>
      </div>
    </div>
  );

  return (
    <Layout className="cm-page">
      <section
        className="cm-hero"
        style={{
          backgroundImage: `url(${ImageUrl("coursesbnr.png")})`,
        }}
      >
        <div className="cm-hero-overlay" aria-hidden />
        <div className="cm-wrap cm-hero-inner">
          <div className="cm-hero-copy">
            <span className="cm-hero-badge">QUIZ MANAGEMENT</span>
            <h1 className="fontFamily1 cm-hero-title">
              Manage Quizzes. <span>Empower Assessment.</span>
            </h1>
            <p className="fontFamily1 cm-hero-sub">
              Build and manage quizzes to assess learner progress with
              confidence.
            </p>
            <div className="cm-hero-actions">
              <Button
                type="primary"
                size="large"
                className="cm-hero-btn-primary"
                onClick={() => navigate("/quiz/add")}
              >
                <span className="cm-hero-btn-plus">
                  <FaPlus />
                </span>
                Add Quiz
              </Button>
            </div>
          </div>
        </div>
      </section>

      <div className="cm-wrap cm-main">
        <div className="cm-panel">
          <div className="cm-toolbar">
            <div className="cm-toolbar-intro">
              <span className="cm-toolbar-icon" aria-hidden>
                <FaClipboardList />
              </span>
              <h2 className="fontFamily1">Quiz Management</h2>
            </div>
            <div className="cm-toolbar-actions">
              <Button
                type="primary"
                className="cm-btn-course"
                onClick={() => navigate("/quiz/add")}
              >
                Add Quiz
              </Button>
            </div>
          </div>

          <div className="cm-sub-toolbar">
            <div className="cm-page-size">
              <span>Show</span>
              <Select
                size={"large"}
                className="cm-limit-select"
                defaultValue={paginationConfig.limit}
                onChange={(e) => handleLimitChange(e)}
                options={[
                  { value: 10, label: "10" },
                  { value: 20, label: "20" },
                  { value: 30, label: "30" },
                  { value: 40, label: "40" },
                  { value: 50, label: "50" },
                ]}
              />
              <span>entries</span>
            </div>
            <div className="cm-search-row">
              <Popover
                content={filterContent}
                trigger="click"
                open={open}
                onOpenChange={handleOpenChange}
                placement="bottomRight"
                arrow={false}
              >
                <Button className="cm-filter-trigger" aria-label="Open filters">
                  <FaFilter />
                </Button>
              </Popover>
              <div className="cm-search-wrap">
                <Input
                  className="cm-search"
                  placeholder="Search quizzes…"
                  value={filter.keyword}
                  onChange={(e) => handleSearch(e.target.value)}
                  onPressEnter={() =>
                    getAllQuiz(1, paginationConfig.limit, filter.keyword)
                  }
                />
                <button
                  type="button"
                  className="cm-search-btn"
                  aria-label="Search quizzes"
                  onClick={() =>
                    getAllQuiz(1, paginationConfig.limit, filter.keyword)
                  }
                >
                  <FaSearch />
                </button>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="cm-skeleton">
              <Skeleton active paragraph={{ rows: 6 }} />
            </div>
          ) : (
            <div className="cm-table-wrap">
              <Table
                className="cm-table"
                dataSource={questions}
                columns={columns}
                pagination={false}
                rowKey={(record, index) =>
                  record._id ?? `quiz-row-${index}`
                }
                scroll={{ x: "max-content" }}
              />
            </div>
          )}

          <div className="cm-pagination-row">
            <p className="fontFamily1 cm-pagination-meta">{recordsMessage}</p>
            <Pagination
              className="styledPagination cm-pagination"
              onChange={(e) => handlePageChange(e)}
              current={parseInt(paginationConfig.pageNumber)}
              pageSize={paginationConfig.limit}
              total={paginationConfig.totalDocs}
              itemRender={itemRender}
            />
          </div>
        </div>
      </div>

      <Modal
        visible={modalOpen}
        onOk={() => handleStatus()}
        onCancel={() => setModalOpen(false)}
        okText="Yes"
        className="StyledModal"
        style={{
          left: 0,
          right: 0,
          marginLeft: "auto",
          marginRight: "auto",
          textAlign: "center",
        }}
        cancelText="No"
        cancelButtonProps={{
          style: {
            border: "2px solid #2484c6",
            color: "#2484c6",
            height: "auto",
            padding: "6px 35px",
            borderRadius: "50px",
            fontSize: "16px",
            marginTop: "15px",
          },
        }}
        okButtonProps={{
          style: {
            backgroundColor: "#2484c6",
            color: "white",
            marginTop: "15px",
            height: "auto",
            padding: "5px 35px",
            borderRadius: "50px",
            fontSize: "16px",
            border: "2px solid #2484c6",
          },
        }}
      >
        <Typography.Title level={4} style={{ fontSize: "25px" }}>
          {selectedUser?.isActive ? "Deactivate" : "Activate"}
        </Typography.Title>
        <Typography.Text style={{ fontSize: 16 }}>
          Do You Want To {selectedUser?.isActive ? "Deactivate" : "Activate"}{" "}
          This Service Provider?
        </Typography.Text>
      </Modal>
    </Layout>
  );
}

export default QuizManagement;
